const { isEmpty } = require('lodash');
const isValidComponent = require('../component');

module.exports = (section = [], isLazy) =>
    Array.isArray(section) && !isEmpty(section) && section.map((curr) => isValidComponent(curr, isLazy)).every(Boolean);
